








import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TanksApi, Tank, TransceiversApi } from '@/api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from 'moment';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {},
	props: {
		transceiverId: Number,
		rawData: Array,
	},
})
export default class TankChartAdmin extends Vue {
	public form = {
		start: moment()
			.subtract(7, 'days')
			.format('DD-MM-YYYY')
			.toString(),
		end: moment()
			.format('DD-MM-YYYY')
			.toString(),
		shortcut: null,
	};
	public graph;
	public transceiverId;
	public chart;
	public tempValueAxis;

	public indicator;

	public mounted() {
		this.graphData();
	}

	// am4core.disposeAllCharts();
	public beforeDestroy() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	public async graphData() {
		try {
			const api = new TransceiversApi();
			const response = await api.getTransceiverData(this.transceiverId);

			//  getFuelGraphData(tankId: number, nDays?: number, series?: string, offset?: string
			this.graph = response.data.data ? response.data.data : [];
		} catch (e) {
			console.log(e);
		}
		this.loadChart();
	}

	public async loadChart() {
		// Themes
		// am4core.useTheme(am4themes_animated);

		if (this.chart) {
			await this.chart.dispose();
		}

		// Create chart instance
		this.chart = am4core.create('chartdiv udp packet' + this.transceiverId, am4charts.XYChart);

		// Increase contrast by taking evey second color
		this.chart.colors.step = 2;

		// this.chart = am4core.options.onlyShowOnViewport = true;

		// Create axes
		const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.renderer.minGridDistance = 50;
		dateAxis.baseInterval = { timeUnit: 'second', count: 1 }; // timeUnit: "minute", count: 5
		// dateAxis.dateFormats.setKey("day", "HH:mm/MMM dd");
		dateAxis.tooltipDateFormat = '[bold]dd-MM-yy, h:mm:ss a[/]';
		// dateAxis.dateFormats.setKey('minute', 'h:mm a');
		dateAxis.renderer.grid.template.location = 0;

		// this.chart.scrollbarY = new am4core.Scrollbar();

		// Add legend and cursor
		this.chart.legend = new am4charts.Legend();
		this.chart.cursor = new am4charts.XYCursor();

		const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		this.createSeries(valueAxis, false, 'data', 'Packet Number', true, 'rectangle', 'black');

		// this.chart.cursor.behavior = 'zoomXY';
		this.chart.cursor.xAxis = dateAxis;

		dateAxis.dateFormatter = new am4core.DateFormatter();
		dateAxis.dateFormatter.dateFormat = 'MM-dd';
	}

	// Create series
	public createSeries(
		valueAxis: am4charts.ValueAxis,
		fillArea: boolean,
		field: string,
		name: string,
		opposite: boolean,
		shape: string,
		lineColor?: string,
		strokeWidth?: number,
	) {
		valueAxis.min = 0;

		// if (field === 'vatTemp' || field === 'inletTemp') {
		//  valueAxis.max = 80;
		// }

		const series = this.chart.series.push(new am4charts.LineSeries());
		series.dataFields.valueY = field;
		series.dataFields.dateX = 'date';
		series.strokeWidth = 0;

		series.yAxis = valueAxis;
		series.tooltipText = '{name}: [bold]{details}[/]';

		series.name = name;
		series.connect = true;
		const skipped = 0;

		if (fillArea) {
			series.fillOpacity = fillArea ? 0.3 : 0;
			if (lineColor) {
				series.fill = lineColor;
			}
		}

		if (lineColor) {
			series.stroke = am4core.color(lineColor);
			series.fill = lineColor;
		}

		const chartData = [];
		for (const row of this.graph) {
			const newDate = new Date(row.date);
			const size = 2;
			const fill = am4core.color('#fff');

			const value = row.data.packetNumber;
			let payload = '';
			const dataPayload = JSON.stringify(row.data);
			let j = 0;
			for (const key in dataPayload) {
				if (dataPayload.hasOwnProperty(key)) {
					dataPayload[key] === ',' ? (payload += '\n') : (payload += dataPayload[key]);
				}
			}
			const dataPoint = {
				date: newDate,
				size,
				[field]: value,
				fill,
				details: payload,
			};

			chartData.push(dataPoint);
		}

		if (this.graph.length < 1) {
			this.showIndicator(field);
		}

		series.data = chartData;

		const interfaceColors = new am4core.InterfaceColorSet();

		// labels
		const bullet = series.bullets.push(new am4charts.CircleBullet());
		// bullet.circle.fill = am4core.color('#fff');
		bullet.circle.strokeWidth = 1;
		bullet.circle.propertyFields.radius = 'size';
		bullet.circle.propertyFields.fill = 'fill';

		valueAxis.renderer.line.strokeOpacity = 1;
		valueAxis.renderer.line.strokeWidth = 2;
		valueAxis.renderer.line.stroke = series.stroke;
		valueAxis.renderer.labels.template.fill = series.stroke;
		valueAxis.renderer.opposite = true;

		valueAxis.renderer.grid.template.disabled = true;
	}

	public showIndicator(field: string) {
		this.indicator = this.chart.tooltipContainer.createChild(am4core.Container);
		this.indicator.background.fill = am4core.color('#fff');
		this.indicator.background.fillOpacity = 0.8;
		this.indicator.width = am4core.percent(100);
		this.indicator.height = am4core.percent(100);
		const indicatorLabel = this.indicator.createChild(am4core.Label);
		indicatorLabel.text = 'No data for this date range...';
		indicatorLabel.align = 'center';
		indicatorLabel.valign = 'middle';
		indicatorLabel.fontSize = 20;
	}
}
